'use strict';

/**
 * @file Marquee 跑马灯
 * @author zhangzhe(zhangzhe@baidu.com)
 */

define(['utils/helpers', 'utils/underscore', 'utils/css'], function (utils, _, cssUtils) {

    var Marquee = function Marquee(model, element) {
        this.model = model;
        this.element = element;
        this.times = 0;
        this.init();
    };

    function getRandomTop(height) {
        return height > 100 ? 30 + Math.random() * (height - 100) : height / 2;
    }

    _.extend(Marquee.prototype, {
        init: function init() {
            if (utils.isMSIE(9)) {
                cssUtils.style(this.element, {
                    display: 'none'
                });
                return false;
            }
            var marqueeText = this.model.get('marquee').text;
            var marqueeColor = this.model.get('marquee').color;
            var marqueeFontsize = this.model.get('marquee').fontSize;
            if (marqueeText) {
                this.element.innerHTML = marqueeText;
            }
            if (marqueeColor) {
                cssUtils.style(this.element, {
                    color: marqueeColor
                });
            }
            if (marqueeFontsize) {
                cssUtils.style(this.element, {
                    fontSize: marqueeFontsize,
                    lineHeight: marqueeFontsize + 8
                });
            }
            this.reset();
        },
        start: function start() {
            // IE9以下不支持跑马灯
            if (utils.isMSIE(9)) {
                return false;
            }

            cssUtils.style(this.element, {
                animationPlayState: 'running',
                opacity: 1,
                display: 'block'
            });
        },

        stop: function stop() {
            this.reset();

            cssUtils.style(this.element, {
                animationPlayState: 'paused',
                opacity: 0,
                display: 'none'
            });
        },

        pause: function pause() {
            if (this.element.style.animationPlayState === 'running') {
                cssUtils.style(this.element, {
                    animationPlayState: 'paused'
                });
            }
            cssUtils.style(this.element, {
                opacity: 0
            });
        },

        reset: function reset(width, height) {
            width = width || this.model.get('width');
            height = height || this.model.get('height');
            var duration = 18;
            var marqueeElement = this.element;
            var marqueeFlag = this.times % 2 === 0 ? 'marquee1' : 'marquee2';
            var me = this;
            cssUtils.animation(marqueeElement, marqueeFlag + ' ' + duration + 's infinite');
            // 随机右边出来的高度
            this.randomTop(marqueeElement, height);
            // 绑定事件
            utils.addEventListener(marqueeElement, 'webkitAnimationIteration', function () {
                me.randomTop(marqueeElement, height);
            }, false);
            utils.addEventListener(marqueeElement, 'animationiteration', function () {
                me.randomTop(marqueeElement, height);
            }, false);

            this.times++;
        },

        randomTop: function randomTop() {
            var height = 0;
            if (this.model.get('containerHeight')) {
                height = this.model.get('containerHeight');
            }
            cssUtils.style(this.element, {
                top: getRandomTop(height)
            });
        }
    });
    return Marquee;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/marquee.js
 ** module id = 202
 ** module chunks = 0
 **/